import * as types from "../constants/actionConstants";
import TemplateApi from "../api/TemplateApi";
import * as TEMPLATE from "../constants/templateConstants";
import * as portalTypes from "../portal/constants/actionConstants";
import {createEditorInstanceId, EDITOR_TYPES} from "../utilities/editorInstanceOwnership";


export function initializeCategoryEditorCreate(template) {
    if (!template) {
        template = {
            metadata: {}
        };
    }

    return {
        type: types.CATEGORY_EDITOR_INITIALIZE,
        payload: {
            instanceId: createEditorInstanceId(EDITOR_TYPES.CATEGORY),
            template: {
                templateKey: (template.templateKey)? template.templateKey : "",
                name: (template.name)? template.name : "",
                nameQualifier: (template.nameQualifier)? template.nameQualifier : null,
                description: (template.description)? template.description : "",
                metadata: {
                    ...template.metadata
                },
                groupKeys: [],
                showGroupKeys: []
            },
            groupKeys: [],
            showGroupKeys: [],
            options: {
                hasDescription: !!template.description,
                createMode: true,
                validate: [],
                isValidating: false
            }
        }
    };
}

export function initializeCategoryEditorUpdate(template) {
    return {
        type: types.CATEGORY_EDITOR_INITIALIZE,
        payload: {
            instanceId: createEditorInstanceId(EDITOR_TYPES.CATEGORY),
            template: template,
            groupKeys: template.groupKeys,
            showGroupKeys: template.showGroupKeys,
            options: {
                hasScript: !!template.script,
                hasDescription: !!template.description,
                createMode: false,
                validate: [],
                isValidating: false
            }
        }
    };
}

export function updateCategoryTemplate(template, options) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_EDITOR_UPDATE, payload: {template, options}});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function clearCategoryEditor() {
    return (dispatch) => {
        dispatch({type: types.CLEAR_CATEGORY_GRAPH});
        dispatch({type: types.CATEGORY_EDITOR_CLEAR});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// export function checkValue(filter) {
//     return (dispatch) => {
//         dispatch({type: types.CATEGORY_EDITOR_NAME_AND_QUALIFIER_VALIDATING});
//         dispatch(checkQuestionCategoryExists(filter))
//     };
// }

export function checkQuestionCategoryExists(filter) {
    let thunk = (dispatch) => {
        TemplateApi.checkQuestionCategoryExists(filter).then((data) => {
            dispatch({type: types.CATEGORY_EDITOR_NAME_AND_QUALIFIER_EXISTS, list: data.collection});
        });
    };

    thunk.meta = {
        debounce: {
            time: 1000,
            key: "__categoryExistsCheck",
            leading: false,
            trailing: true
        }
    };

    return thunk;
}

export function validateCategoryNameAndQualifierUnique(name, qualifier, depth = 0) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_EDITOR_NAME_AND_QUALIFIER_VALIDATING, depth: depth});
        dispatch(validateCategoryNameAndQualifierExists(name, qualifier, depth))
    };
}

export function validateCategoryNameAndQualifierExists(name, qualifier) {

    let nameQualifier = qualifier === null ? "" : qualifier;

    let thunk = (dispatch) => {
        TemplateApi.checkTemplateNameAndQualifierExists(TEMPLATE.TYPE.CATEGORY, name, nameQualifier).then((data) => {
            dispatch({type: types.CATEGORY_EDITOR_NAME_AND_QUALIFIER_EXISTS, list: data.collection, depth: 0});
        });
    };

    thunk.meta = {
        debounce: {
            time: 1000,
            key: "__questionExistsCheck",
            leading: false,
            trailing: true
        }
    };

    return thunk;
}


// ---------------------------------------------------------------------------------------------------------------------
// Categories can have associated groups
// ---------------------------------------------------------------------------------------------------------------------

export function addCategoryGroup(groupKey) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_EDITOR_ADD_GROUP, groupKey: groupKey});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function removeCategoryGroup(index) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_EDITOR_REMOVE_GROUP, index: index});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function reorderCategoryGroup(isUp, currentIndex) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_EDITOR_REORDER, isUp: isUp, currentIndex: currentIndex});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// ---------------------------------------------------------------------------------------------------------------------
// Category show group keys
// ---------------------------------------------------------------------------------------------------------------------

export function addCategoryShowGroupKeys(template, showGroupKeys = []) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_EDITOR_ADD_SHOW_GROUP_KEYS, payload: {template}, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function removeCategoryShowGroupKeys(template, showGroupKeys = []) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_EDITOR_REMOVE_SHOW_GROUP_KEYS, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function setCategoryShowGroupKeys(removedGroupKey, showGroupKeys = []) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_EDITOR_SET_SHOW_GROUP_KEYS, removedGroupKey: removedGroupKey, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

